"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.groups.selectNumber': 'Phone Number',
    'whatsapp.groups.selectNumberPlaceholder': 'Select a phone number...',
    'whatsapp.groups.loadFailed': 'Failed to load WhatsApp groups.',
    'whatsapp.groups.noGroups': 'No groups found. Start the agent to sync your WhatsApp groups.',
    'whatsapp.groups.trackingOn': 'Tracking',
    'whatsapp.groups.trackingOff': 'Not tracking',
    'whatsapp.groups.loading': 'Loading...',
    'whatsapp.groups.notFound': 'Group not found.',
    'whatsapp.groups.info': 'Group information',
    'whatsapp.groups.name': 'Name',
    'whatsapp.groups.waId': 'WhatsApp ID',
    'whatsapp.groups.teleId': 'Telegram ID',
    'whatsapp.groups.phone': 'Phone number',
    'whatsapp.groups.tracking': 'Enable message tracking',
    'whatsapp.groups.pinMessage.label': 'Pinned message',
    'whatsapp.groups.pinMessage.placeholder': 'Message content to pin in the group...',
    'whatsapp.groups.pinMessage.hint': 'When tracking is enabled and the bot is an admin, this message will be pinned.',
    'whatsapp.groups.pinReminder.label': 'Repost pinned message',
    'whatsapp.groups.pinReminder.intervalLabel': 'Interval (hours)',
    'whatsapp.groups.pinReminder.hint': 'Reposts the pinned message when at least 10 new messages have arrived since the last reminder.',
    'whatsapp.groups.tracking.badge': 'Tracked',
    'whatsapp.groups.communicationType.wa': 'WA',
    'whatsapp.groups.communicationType.tele': 'TELE',
    'whatsapp.groups.trackingEnabled': 'Message tracking enabled.',
    'whatsapp.groups.trackingDisabled': 'Message tracking disabled.',
    'whatsapp.groups.trackingFailed': 'Failed to update tracking settings.',
    'whatsapp.groups.messages': 'Tracked messages',
    'whatsapp.groups.noMessages': 'No tracked messages yet.',
    'whatsapp.groups.openGroup': 'Open group',
    'whatsapp.groups.back': 'Back',
    'whatsapp.groups.copyUrl.label': 'Copy public link',
    'whatsapp.groups.copyUrl.copied': 'Copied!',
    'whatsapp.groups.copyUrl.title': 'Copy a public link to this group (with optional phone-number filter)',
    'whatsapp.groups.copyUrl.success': 'Public link copied to clipboard.',
    'whatsapp.groups.copyUrl.failed': 'Failed to copy public link.',
    'whatsapp.groups.botSettings': 'Bot Settings',
    'whatsapp.groups.avatar': 'Avatar',
    'whatsapp.groups.selectAvatar': '-- Select Avatar --',
    'whatsapp.groups.botInstruction': 'Bot Instruction',
    'whatsapp.groups.botInstructionPlaceholder': 'Enter instructions for the WhatsApp bot...',
    'whatsapp.groups.saveSettings': 'Save Settings',
    'whatsapp.groups.settingsSaved': 'Settings saved successfully.',
    'whatsapp.groups.settingsFailed': 'Failed to save settings.',
    'whatsapp.groups.listTitle': 'WhatsApp Groups',
    'whatsapp.groups.addGroup': 'Add Group',
    'whatsapp.groups.announce.label': 'All users can write in group',
    'whatsapp.groups.announce.hint': 'When enabled, all group members can send messages (not just admins).',
    'whatsapp.groups.announce.saved': 'Announce mode updated.',
    'whatsapp.groups.announce.failed': 'Failed to update announce mode.',
    'whatsapp.groups.remoteAccess.label': 'Remote Access',
    'whatsapp.groups.accessPassword.label': 'Access Password',
    'whatsapp.groups.security.save': 'Set Security',
    'whatsapp.groups.security.saved': 'Security settings saved.',
    'whatsapp.groups.security.failed': 'Failed to save security settings.',
    'whatsapp.groups.gate.title': 'Group Access',
    'whatsapp.groups.gate.password': 'Password',
    'whatsapp.groups.gate.submit': 'Enter',
    'whatsapp.groups.gate.error': 'Invalid password. Please try again.',
    'whatsapp.groups.gate.notAllowed': 'This group is not available for the selected phone number.',
    'whatsapp.groups.dateFrom': 'From',
    'whatsapp.groups.dateTo': 'To',
    'whatsapp.groups.summarize': 'Summarize',
    'whatsapp.groups.summary': 'Summary',
    'whatsapp.groups.summaries.title': 'Summaries',
    'whatsapp.groups.summaries.empty': 'No summaries yet.',
    'whatsapp.groups.summaries.date': 'Date',
    'whatsapp.groups.summaries.view': 'View',
    'whatsapp.groups.summaries.excerpt': 'Summary',
    'whatsapp.groups.summaries.modalTitle': 'Summary Details',
    'whatsapp.groups.summarizeDone': 'Summary generated successfully.',
    'whatsapp.groups.summarizeFailed': 'Failed to generate summary.',
    'whatsapp.groups.syncMessages.button': 'Sync Messages',
    'whatsapp.groups.syncMessages.done': 'Messages synced successfully.',
    'whatsapp.groups.sendMessage.title': 'Send Message',
    'whatsapp.groups.sendMessage.placeholder': 'Type a message to send to the group...',
    'whatsapp.groups.sendMessage.send': 'Send',
    'whatsapp.groups.sendMessage.success': 'Message sent.',
    'whatsapp.groups.sendMessage.failed': 'Failed to send message.',
    'whatsapp.groups.trackingDisabledHint': 'Tracking is disabled for this group. Enable tracking to view messages, send messages, and summaries.',
    'whatsapp.groups.syncMessages.failed': 'Failed to sync messages.',
    'whatsapp.groups.media.download': 'Download',
    'whatsapp.groups.media.downloading': 'Downloading...',
    'whatsapp.groups.media.downloadFailed': 'Failed to download media.',
    'whatsapp.groups.media.attachment': 'Attachment',
    'whatsapp.groups.agentChecking': 'Checking WhatsApp agent status...',
    'whatsapp.groups.agentOffline': 'WhatsApp agent is offline. All actions requiring agent connection are disabled.',
    'whatsapp.groups.loading_groups': 'Loading groups...',
    'whatsapp.groups.members.title': 'Group Members',
    'whatsapp.groups.members.sync': 'Sync',
    'whatsapp.groups.members.syncFailed': 'Failed to sync members.',
    'whatsapp.groups.members.empty': 'No members found. Click Sync to load from WhatsApp.',
    'whatsapp.groups.members.phone': 'Phone',
    'whatsapp.groups.members.username': 'Username',
    'whatsapp.groups.members.id': 'WA ID',
    'whatsapp.groups.members.name': 'Name',
    'whatsapp.groups.members.role': 'Role',
    'whatsapp.groups.members.superAdmin': 'Super Admin',
    'whatsapp.groups.members.admin': 'Admin',
    'whatsapp.groups.members.member': 'Member',
    'whatsapp.groups.members.promote': 'Promote to Admin',
    'whatsapp.groups.members.promoted': 'Member promoted to admin.',
    'whatsapp.groups.members.promoteFailed': 'Failed to promote member.',
    'whatsapp.groups.addParticipants.title': 'Add Participants',
    'whatsapp.groups.addParticipants.phonePlaceholder': 'Enter phone number...',
    'whatsapp.groups.addParticipants.addPhone': 'Add Phone',
    'whatsapp.groups.addParticipants.noPhonesYet': 'No phone numbers added yet.',
    'whatsapp.groups.addParticipants.submit': 'Add Participants',
    'whatsapp.groups.addParticipants.success': 'Participants added successfully.',
    'whatsapp.groups.addParticipants.failed': 'Failed to add participants.',
    'whatsapp.groups.members.remove': 'Remove',
    'whatsapp.groups.members.removed': 'Member removed from group.',
    'whatsapp.groups.members.removeFailed': 'Failed to remove member.',
    'whatsapp.groups.members.feedBotData': 'Feed Bot Data',
    'whatsapp.groups.members.allowBotUsage': 'Allow Bot Usage',
    'whatsapp.groups.members.updateFailed': 'Failed to update member settings.',
    'whatsapp.groups.joinGroup': 'Join Group',
    'whatsapp.groups.joinLink.modalTitle': 'Join WhatsApp Group',
    'whatsapp.groups.joinLink.hint': 'Paste a WhatsApp group invite link (e.g. https://chat.whatsapp.com/...) and the agent will join that group.',
    'whatsapp.groups.joinLink.label': 'Invite link',
    'whatsapp.groups.joinLink.placeholder': 'https://chat.whatsapp.com/...',
    'whatsapp.groups.joinLink.required': 'Please enter an invite link.',
    'whatsapp.groups.joinLink.submit': 'Join',
    'whatsapp.groups.joinLink.cancel': 'Cancel',
    'whatsapp.groups.joinLink.success': 'Successfully joined the group.',
    'whatsapp.groups.joinLink.failed': 'Failed to join the group.',
    'whatsapp.groups.trackLogs': 'Activity Log',
    'whatsapp.groups.trackLogs.noLogs': 'No activity logs yet.',
    'whatsapp.groups.trackLogs.logType.neutral': 'Neutral',
    'whatsapp.groups.trackLogs.logType.good': 'Good',
    'whatsapp.groups.trackLogs.logType.warning': 'Warning',
    'whatsapp.groups.trackLogs.logType.critical': 'Critical',
};
